import React from 'react';
import { testimonials as defaultTestimonials } from '../engagementContent';

const SocialProofSection = ({
  items = defaultTestimonials,
  eyebrow = 'Teams who hired Kolanut',
  title = 'Founders who added an engagement manager without a new salary',
}) => {
  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="mb-8 md:mb-10">
          <p className="text-[11px] sm:text-xs font-medium uppercase tracking-[0.18em] text-gray-400 mb-3">
            {eyebrow}
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-[2rem] font-semibold tracking-tight text-gray-900 leading-snug max-w-2xl">
            {title}
          </h2>
        </div>

        <div className="rounded-2xl border border-gray-200 bg-white overflow-hidden divide-y divide-gray-100">
          {items.map((item) => (
            <blockquote
              key={item.name}
              className="grid gap-4 px-6 py-6 sm:px-8 sm:py-7 md:grid-cols-[1fr_auto] md:items-end md:gap-10"
            >
              <p className="text-[15px] sm:text-base text-gray-700 leading-relaxed">
                &ldquo;{item.quote}&rdquo;
              </p>
              <footer className="md:text-right shrink-0">
                <p className="font-semibold text-gray-900 text-sm">{item.name}</p>
                <p className="text-xs text-gray-400 mt-0.5">{item.role}</p>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
